import type { CommonSVGProps } from './helpers';

export const HomeIcon = (props: CommonSVGProps) => {
  return (
    <svg fill="none" height="18" viewBox="0 0 18 18" width="18" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M11.25 15.75V9.74998C11.25 9.55106 11.171 9.3603 11.0303 9.21965C10.8897 9.07899 10.6989 8.99998 10.5 8.99998H7.5C7.30109 8.99998 7.11032 9.07899 6.96967 9.21965C6.82902 9.3603 6.75 9.55106 6.75 9.74998V15.75M2.25 7.49998C2.24995 7.28178 2.2975 7.06619 2.38934 6.86826C2.48118 6.67033 2.6151 6.49482 2.78175 6.35398L8.03175 1.85473C8.30249 1.62591 8.64552 1.50037 9 1.50037C9.35448 1.50037 9.69751 1.62591 9.96825 1.85473L15.2183 6.35398C15.3849 6.49482 15.5188 6.67033 15.6107 6.86826C15.7025 7.06619 15.7501 7.28178 15.75 7.49998V14.25C15.75 14.6478 15.592 15.0293 15.3107 15.3106C15.0294 15.5919 14.6478 15.75 14.25 15.75H3.75C3.35218 15.75 2.97064 15.5919 2.68934 15.3106C2.40804 15.0293 2.25 14.6478 2.25 14.25V7.49998Z"
        stroke="#3D3D3D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.6"
      />
    </svg>
  );
};
